import { jsx as _jsx } from "react/jsx-runtime";
import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
export default function Tabs({ items = [], ...props }) {
    return (_jsx(MuiTabs, { ...props, children: items.map((tabProps, i) => (_jsx(MuiTab, { ...tabProps }, i))) }));
}
export * from '@mui/material/Tabs';
